import React from 'react'
import { Button, ButtonProps, Typography } from '@material-ui/core'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import { useStyles } from './LoginButton.styles'

interface LoginButtonProps extends ButtonProps {
  isLoggedIn: any
}

const LoginButton: React.FC<LoginButtonProps> = ({
  isLoggedIn,
  ...props
}: LoginButtonProps) => {
  const classes = useStyles()
  return (
    <>
      {!isLoggedIn ? (
        <Button variant="contained" className={classes.loginButton} {...props}>
          <Typography variant="h6" className={classes.loginButtonText}>
            Login
          </Typography>
        </Button>
      ) : (
        <Button
          className={classes.loginButtonActive}
          variant="outlined"
          {...props}
        >
          <AccountCircleOutlinedIcon fontSize="small" />
          <Typography variant="h6" className={classes.loginButtonText}>
            {isLoggedIn.name.split(' ')[0]}
          </Typography>
        </Button>
      )}
    </>
  )
}

export default LoginButton
